// Display only: the Google credential is never trusted client-side, the backend verifies it.
export function readEmailFromCredential(credential: string): string | null {
  const payload = credential?.split('.')[1];
  if (!payload) {
    return null;
  }

  try {
    const json = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    const email: unknown = JSON.parse(json).email;

    return typeof email === 'string' && email.length > 0 ? email : null;
  } catch {
    return null;
  }
}
